export const marketplace = {
  marketplaceSearchInputPlaceholderTitle: 'Paieška',
  marketplaceDetailsCurtainCopyOptionTitle: 'Kopijuoti nuorodą',
  marketplaceDetailsCurtainFlagOptionTitle: 'Pažymėti turinį',
  marketplaceDetailsCurtainCopiedAlertText: 'Nuoroda nukopijuota!',
  marketplaceDetailsFlagCurtainTitle: 'Pažymėti',
  marketplaceReportedCurtainContent: 'Turinys pažymėtas',
  marketplaceAllItems: 'Visi daiktai',
  marketplaceWantToBuy: 'Noriu nusipirkti {item} iš {appname}'
}
